import { Box, Typography } from "@mui/material";

const CustomInstructionBox = ({ heading, textOne, textTwo, textThree }) => {
  return (
    <Box
      sx={{
        backgroundColor: "#F0F8FF",
        border: "1px solid #E0E7FF",
        borderRadius: "8px",
        padding: "2em",
        display: "flex",
        flexDirection: "column",
        gap: "1em",
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 700, color: "#1F2937" }}>
        {heading}
      </Typography>
      <Typography variant="body2" sx={{ color: "#4B5563" }}>
        • {textOne}
      </Typography>
      <Typography variant="body2" sx={{ color: "#4B5563" }}>
        • {textTwo}
      </Typography>
      <Typography variant="body2" sx={{ color: "#4B5563" }}>
        • {textThree}
      </Typography>
    </Box>
  );
};

export default CustomInstructionBox;
